import { render, staticRenderFns } from "./DescargaActividadForm.vue?vue&type=template&id=1e9ed94e&"
import script from "./DescargaActividadForm.vue?vue&type=script&lang=ts&"
export * from "./DescargaActividadForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports